import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const NewsSingle = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/news/list`);
        const articleid = window.location.href.split('/').pop();
        if (articleid) {
          setNews(response.data.data.filter((item) => String(item.id) === articleid)[0]);
        } else {
          navigate('/news/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const prettyDate = (zuluDate) => {
    const date = new Date(zuluDate);

    const formattedDate = `${date.toLocaleDateString('en-ZA', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} ${date.toLocaleTimeString('en-ZA', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;

    return formattedDate;
  };

  return (
    <>
      <PageHeader title="News Article Details" description="" className="mb-3"></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : news?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Title: {news.title}</td>
            </tr>
            <tr>
              <td>
                Thumbnail article image:
                <br />
                {news.thumb_image_file ? (
                  <img className="rounded" height={300} src={news.thumb_image_file} alt={news.title} />
                ) : (
                  <>
                    No image
                    <br />
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td>
                Inside article image:
                <br />
                {news.image_file ? (
                  <img className="rounded" height={300} src={news.image_file} alt={news.title} />
                ) : (
                  <>
                    No image
                    <br />
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td>Audience: {news.audience}</td>
            </tr>
            <tr>
              <td>Enabled: {news.enabled}</td>
            </tr>
            <tr>
              <td>Featured: {news.featured}</td>
            </tr>
            <tr>
              <td>Keywords: {news.keywords}</td>
            </tr>
            <tr>
              <td>Author: {news.credit}</td>
            </tr>
            <tr>
              <td>Content: {news.content}</td>
            </tr>
            <tr>
              <td>Brief: {news.brief}</td>
            </tr>
            <tr>
              <td>Date added: {prettyDate(news.date_added)}</td>
            </tr>
            <tr>
              <td>Date updated: {prettyDate(news.date_updated)}</td>
            </tr>
            <tr>
              <td>Post date: {prettyDate(news.post_date)}</td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Article not found</div>
      )}
    </>
  );
};

export default NewsSingle;
